import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { usersSelector } from '../../../users/selectors/users';
import { getTypingUsersRequest, setUsers } from '../../../users/actions/users';
import AutoCompleteUsers from './AutoCompleteUsers';

const mapStateToProps = createStructuredSelector({
    users: usersSelector,
});
const mapDispatchToProps = {
    getTypingUsersRequest,
    setUsers
};

export default connect(mapStateToProps, mapDispatchToProps)(AutoCompleteUsers);